import { Button, Checkbox, createTheme, FormHelperText, InputLabel, MenuItem, Select, TextField, ThemeProvider, Typography } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import Grid from '@mui/material/Grid';
import ListItemText from '@mui/material/ListItemText';
import { FormattedMessage, useIntl } from 'react-intl';
import ErrorSnackbarNotification from '../../common/ErrorHandling/ErrorSnackbarAlert';
import { styles } from '../../style/style';

const theme = createTheme({
    //sets color of text in dropdown/selectors 
        palette: {
          primary: {
            main: '#00439D',
          },
          secondary: {
            main: '#11cb5f',
          },
        },
      });

export function OrderSummaryAppName(props) {
    return (
        <>
            <Typography id="orderSummaryTitle" variant="h2" sx={styles.h2PageTitle}><><FormattedMessage id='ordersummarycomponents.appname' defaultMessage='Order Summary' /> {props.companyName}</></Typography>
            <Grid container sx={{pt:'2%', pl: '3%'}}>
                <Typography id="orderSummarySearchTitle" variant="h3" sx={styles.h3SectionTitle}><FormattedMessage id='ordersummarycomponents.searchcriteria' defaultMessage='Search Criteria' /></Typography>
            </Grid>
        </>
    )
}

export function ChargeToBacLabel(props) {
    return (
        <>
            <Typography variant="h4" sx={styles.chargeToBacOrPrimaryFanLabelh4InformationGroup}>
                <strong><FormattedMessage id='ordersummarycomponents.chargetobac' defaultMessage='Charge to Business Associate Code (BAC)' /></strong>
            </Typography>
            <Typography variant="caption" sx={styles.chargeToBacOrPrimaryFanLabelPBody}>{props.bacNumber}</Typography>
        </>
    )
}
export function ChargeToBacText(props) {
    const intl = useIntl();
    return (
        <>
            <TextField
                variant='filled'
                value={props.value}
                id={props.id}
                sx={styles.orderSummaryTextField}
                InputLabelProps={{ style: { fontSize: 16 } }}
                label={intl.formatMessage({ id: "ordersummarycomponents.chargetobac", defaultMessage: "Charge to Business Associate Code (BAC)" })}
                onChange={props.onChangeChargeToBac}
                error={props.error !== "" && props.error !== null} />
        </>
    )
}
export function PrimaryFanLabel(props) {
    return (
        <>
            <Typography variant="h4" sx={styles.chargeToBacOrPrimaryFanLabelh4InformationGroup}>
                {props.partnerType === 'FLEET' && (<strong><FormattedMessage id='ordersummarycomponents.fan' defaultMessage='Fleet Account Number (FAN)' /></strong>)}
                {props.partnerType !== 'FLEET' && (<strong><FormattedMessage id='ordersummarycomponents.primaryfan' defaultMessage='Primary Fleet Account Number (FAN)' /></strong>)}
            </Typography>
            <Typography variant="caption" sx={styles.chargeToBacOrPrimaryFanLabelPBody}>{props.primaryFan}</Typography>
        </>
    )
}
export function PrimaryFanText(props) {
    const intl = useIntl();
    return (
        <>
            <TextField
                variant='filled'
                value={props.value}
                id={props.id}
                sx={styles.orderSummaryTextField}
                InputLabelProps={{ style: { fontSize: 16 } }}
                label={intl.formatMessage({ id: "ordersummarycomponents.primaryfan", defaultMessage: "Primary Fleet Account Number (FAN)" })}
                onChange={props.onChangePrimaryFan}
                error={props.error !== "" && props.error !== null} />
        </>
    )
}
export function EndUserFan(props) {
    const intl = useIntl();
    return (
        <>
            <TextField
                variant='filled'
                value={props.value}
                id={props.id}
                sx={styles.orderSummaryTextField}
                InputLabelProps={{ style: { fontSize: 16 } }}
                label={intl.formatMessage({ id: "ordersummarycomponents.enduserfan", defaultMessage: "End User Fleet Account Number (FAN)" })}
                onChange={props.onChangeEndUserFan}
                error={props.error !== "" && props.error !== null} />
        </>
    )
}
export function ModelYear(props) {
    return (
        <>
            <FormControl variant='filled' sx={styles.orderSummarySelect}>
            <ThemeProvider theme={theme}>
                <InputLabel><FormattedMessage id="ordersummarycomponents.modelyear" defaultMessage="Model Year" /></InputLabel>
            </ThemeProvider>
                <Select
                    id="modelYear"
                    variant='filled'
                    labelId="modelYear"
                    multiple
                    value={props.selectedYear}
                    onChange={props.handleCheck}
                    renderValue={(selected) => selected.join(', ')}
                    MenuProps={{ disableScrollLock: true }}
                    error={props.modelYearRequired !== ""}
                >
                    {props.options.map((option) => (
                        <MenuItem id={option} key={option} value={option}>
                            <Checkbox checked={props.selectedYear.indexOf(option) > -1} />
                            <ListItemText primary={option} />
                        </MenuItem>
                    ))}
                </Select>
                <FormHelperText hidden={props.modelYearRequired === ""} error>{props.modelYearRequired}</FormHelperText>
            </FormControl>
        </>
    )
}

export function ChargeToBfc(props) {
    const intl = useIntl();
    return (
        <>
            <TextField
                variant='filled'
                value={props.value}
                id={props.id}
                sx={styles.orderSummaryTextField}
                InputLabelProps={{ style: { fontSize: 16 } }}
                label={intl.formatMessage({ id: "ordersummarycomponents.chargetobfc", defaultMessage: "Charge-To Function Code (BFC)" })}
                onChange={props.onChangeChargeBfc}
                error={props.error !== "" && props.error !== null} />
        </>
    )
}
export function ShipToBac(props) {
    const intl = useIntl();
    return (
        <>
            <TextField
                variant='filled'
                value={props.value}
                id={props.id}
                sx={styles.orderSummaryTextField}
                InputLabelProps={{ style: { fontSize: 16 } }}
                label={intl.formatMessage({ id: "ordersummarycomponents.shiptobac", defaultMessage: "Ship-To Business Associate Code (BAC)" })}
                onChange={props.onChangeShipBac}
                error={props.error !== "" && props.error !== null} />
        </>
    )
}


export function ClearButton(props) {
    return (
        <>
            <Button id="clearButton" sx={styles.orderSummaryClear} onClick={props.clearForm} ><FormattedMessage id='ordersummarycomponents.clear' defaultMessage='Clear' /></Button>
        </>
    )
}


export function SearchButton(props) {
   
    const {open,handleClose,errorType} = props
    let errorMessage = []

    if (props.statusMessage !== "" && props.statusMessage !== null) {
        errorMessage.push(props.statusMessage+"\n")
    }
    if (props.invalidChargeToBacMessage !== "" && props.invalidChargeToBacMessage !== null) {
        errorMessage.push(props.invalidChargeToBacMessage+"\n")
    }
    if (props.invalidChargeToBfcMessage !== "" && props.invalidChargeToBfcMessage !== null) {
        errorMessage.push(props.invalidChargeToBfcMessage +"\n")
    }

    if (props.invalidEndUserFanMessage !== "" && props.invalidEndUserFanMessage !== null) {
        errorMessage.push(props.invalidEndUserFanMessage+"\n")
    }
    if (props.invalidPrimaryFanMessage !== "" && props.invalidPrimaryFanMessage !== null) {
        errorMessage.push(props.invalidPrimaryFanMessage+"\n")
    }
    if (props.invalidShipToBacMessage !== "" && props.invalidShipToBacMessage !== null) {
        errorMessage.push(props.invalidShipToBacMessage+"\n")
    }

    return (
        <>
            <Button id="searchButton" sx={styles.orderSummarySearch} onClick={props.submitHandler} ><FormattedMessage id='ordersummarycomponents.search' defaultMessage='Search' /></Button>
            {errorMessage.length>0  &&
                <ErrorSnackbarNotification errorType={errorType} open={open} handleClose={handleClose} errorMessage={errorMessage} />
            }
        </>
    )
}
